import { Component, Injectable, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Tenant } from 'src/app/shared/models/tenant';
import { OverlayContainer } from '@angular/cdk/overlay';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { MembersService } from '../shared/services/members.service';
import { skip } from 'rxjs/operators';

@Component({
  selector: 'app-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.scss'],
  standalone: false
})
@Injectable()
export class MembersComponent implements OnInit, OnDestroy {
  public tenant: Tenant;
  private subscriptions: Subscription[] = [];
  logoUrl: string;
  helpLink: string;

  constructor(
    private appConfigService: AppConfigService,
    overlayContainer: OverlayContainer,
    private memberService: MembersService
  ) {
    overlayContainer.getContainerElement().classList.add('neutral-theme');
  }

  ngOnInit(): void {
    this.tenant = this.appConfigService.tenant;
    this.subscriptions.push(
      this.memberService.workspaceLogoUrl.pipe(skip(1)).subscribe((result) => {
        if (result) {
          this.logoUrl = result;
        } else {
          this.logoUrl = this.tenant.logoUrl;
        }
      }),
      this.memberService.workspaceHelpLink.pipe(skip(1)).subscribe((result) => {
        if (result) {
          this.helpLink = result;
        } else {
          this.helpLink = this.tenant.tenantHelpLink;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
